import React from 'react';

const FooterContent = (props) => {
    const {content} = props;

    return (
        <ul className="footer-content-outer-container" role="list">
            {content.map((section) => (
              <li className="footer-content-inner-container" role="listitem">
                <h3 className="footer-content-section-title">
                  {section.title}
                </h3>
                <ul className="footer-content-section-outer-container" role="list">
                  {section.content.map(({url, text}) => (
                    <li className="footer-content-section-inner-container" role="listitem">
                      <div className="footer-content-section-redirect-link-outer">
                        <a
                          aria-label="List your property"
                          href={url}
                          target="_self"
                          className="footer-content-section-redirect-link"
                          role="link"
                        >
                          {text}
                        </a>
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
    );
};

export default FooterContent;
